import lrDataPanel from './_src/lrDataPanel.vue'

lrDataPanel.install = function(Vue) {
  Vue.component(lrDataPanel.name, lrDataPanel)
}

export default lrDataPanel